import { ComponentProps } from "react"

import { PathBuilder } from "~/src/lib/iname"

export type HiddenInputProps = { name?: PathBuilder | string } & Omit<ComponentProps<"input">, "name">

/**
 * A Beekit hidden input with support for a `PathBuilder` name & fowards refs.
 */
export function HiddenInput(props: HiddenInputProps) {
  const { name, ...restProps } = props

  return <input type="hidden" name={name?.toString()} {...restProps} />
}
